module.exports = __webpack_public_path__ + "static/media/success-icon.973096e7.svg";